import { api } from "./client";

export type ScannerRow = {
  id: string;
  name: string;
  host_agent_id: string;
  host_name: string;
  available: boolean;
  last_seen_at: string;
};

export type ColorMode = "color" | "gray" | "bw";

export type ScanJobStatus = {
  id: string;
  status: "pending" | "ready" | "failed";
  error_message: string;
  filename: string;
};

export async function listScanners() {
  const { data } = await api.get<ScannerRow[]>("/scanners/");
  return data;
}

export async function startScan(id: string, colorMode: ColorMode, dpi: number) {
  const { data } = await api.post<{ job_id: string }>(`/scanners/${id}/scan`, {
    color_mode: colorMode,
    dpi,
  });
  return data;
}

export async function getScanJob(jobId: string) {
  const { data } = await api.get<ScanJobStatus>(`/scanners/jobs/${jobId}`);
  return data;
}

/** Downloads the scanned picture and hands it to the browser as a file. */
export async function downloadScan(jobId: string, filename: string) {
  const { data } = await api.get<Blob>(`/scanners/jobs/${jobId}/download`, { responseType: "blob" });
  const url = URL.createObjectURL(data);
  try {
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || "scan.jpg";
    document.body.appendChild(a);
    a.click();
    a.remove();
  } finally {
    setTimeout(() => URL.revokeObjectURL(url), 10_000);
  }
}
